<div id="map" class="full-collapse-horizontal" style="height: 100%;"></div>
